// This stub file only exists because I can't seem to successfully
// do an async import on react-app.scss in `app/react-app.tsx`
/* eslint-disable import/no-webpack-loader-syntax */
/* eslint-disable import/no-unresolved */
const bootstrap4 = require('./react-app-styles.scss');
const bootstrap4components = require('./react-app-component-styles.scss');

export { bootstrap4, bootstrap4components };
